import { DndProvider } from "react-dnd";
import { ElementStore, ReactFormBuilder, Registry } from "react-form-builder2";
import { HTML5Backend } from "react-dnd-html5-backend";
import "react-form-builder2/dist/app.css";
import { forwardRef, useEffect, useState } from "react";
import Loader from "../Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import {
  createSurveyForm,
  createSurveyFormClear,
} from "../../redux/survey/action";
import { SessionKeys } from "../../utils/AppUtils";
import CONFIG from "../../utils/config";
import {
  showSurvey,
  showSurveyClear,
  showTemplate,
  showTemplateClear,
} from "../../redux/learningPath/actions";
// import FormElementsEdit from "./FormBuilderEdit";

const InputText2 = forwardRef((props, ref) => {
  const { name, defaultValue, disabled } = props;
  return (
    <input
      ref={ref}
      name={name}
      defaultValue={defaultValue}
      disabled={disabled}
    />
  );
});
Registry.register("InputText2", InputText2);

const FormBuilderSection = ({ isMobile }) => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const is_edit = params.get("is_edit");
  const surveyId = params.get("survey_id");
  const surveyTemplateId = params.get("survey_template_id");

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [formJSON, setFormJSON] = useState([]);
  const [enableBtn, setEnableBtn] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [showInfoModalMsg, setShowInfoModalMsg] = useState("");
  const [surveyRes, setSurveyRes] = useState([]);
  const [surveyTitle, setSurveyTitle] = useState("");
  const [items] = useState([
    { key: "Dropdown" },
    { key: "Checkboxes" },
    { key: "TextInput" },
    { key: "TextArea" },
    { key: "Rating" },
    { key: "Range" },
    { key: "RadioButtons" },
    { key: "NumberInput" },
    {
      // group_name: 'Custom Element',
      key: "InputText2",
      element: "CustomElement",
      component: InputText2,
      type: "custom",
      forwardRef: true,
      bare: true,
      field_name: "my_input_",
      name: "My Input",
      icon: "fa fa-cog",
      props: { test: "test_input" },
      label: "Label Input",
    },
  ]);

  const createSurveyData = useSelector(
    (state) => state.survey.createSurveyData
  );
  const surveyData = useSelector(
    (state) => state.learningPath.showSurveyListing
  );
  const templateData = useSelector(
    (state) => state.learningPath.templateListing
  );

  useEffect(() => {
    if (surveyTemplateId && is_edit === "1") {
      console.log("Teamplate ID", surveyTemplateId);
      setIsLoading(true);
      let obj = {
        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        survey_template_id: surveyTemplateId,
      };
      dispatch(
        showTemplate({
          module: "show-template",
          postData: obj,
        })
      );
    }
  }, [surveyId, surveyTemplateId]);

  useEffect(() => {
    if (!_.isEmpty(templateData) && is_edit === "1") {
      console.log("templateData", templateData);
      setIsLoading(false);
      if (templateData.status === "success") {
        console.log("template Data", templateData);
        let templateRes1 = templateData?.payload?.payload;
        // JSON.parse(surveyRes1?.form_json);
        setFormJSON(JSON.parse(templateRes1?.form_json));
        console.log("json---", JSON.parse(templateRes1?.form_json));
        setSurveyRes(templateRes1);
        setTimeout(() => {
          handleSurveyData();
        }, 500);
      } else {
        setShowInfoModalMsg("Unable to get survey, please try again later.");
        setInfoModal(true);
      }

      dispatch(showTemplateClear());
    }
  }, [templateData]);

  useEffect(() => {
    return () => {};
  }, [surveyRes]);

  useEffect(() => {
    console.log("FORM IS UPDATED");
    addLinkFontAwesome();
    window.addEventListener("message", handleSubmitData);
  }, [dispatch]);

  useEffect(() => {
    ElementStore.subscribe((state) => {
      console.log(state.data);
      setFormJSON(state.data);
    });

    document.addEventListener("click", (e) => {
      hideElementFunc();
    });
  }, []);

  const hideElementFunc = () => {
    hideTag("display-horizontal");
    hideTag("page-break-before-element");
    hideTag("display-on-alternate");
    hideTag("optionsApiUrl");
    hideTag("btn btn-success");

    hideByValue("Print options");
    hideByValue("Alternate/Signature Page");
    hideByValue("Populate Options from API");
    hideButton("Populate");

    hideDivByClassName("col-sm-1");
    hideDivByClassName("col-sm-2");
    // hideDivByClassName("col-sm-3");
    hideDivByClassName("col-sm-4");
  };

  useEffect(() => {
    handleSurveyData();
  }, []);

  const handleSurveyData = (evt) => {
    const targetNode = document.querySelector(
      ".col-md-9.react-form-builder-preview.float-left"
    );

    if (targetNode) {
      const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
          if (
            mutation.attributeName === "class" &&
            targetNode.classList.contains("is-editing")
          ) {
            console.log("🚨 is-editing class added!");
            setTimeout(() => {
              hideElementFunc();

              resetInputValue("Place holder option 1");
              resetInputValue("Place holder option 2");
              resetInputValue("Place holder option 3");
              resetInputValue("Place holder option 4");
            }, 200);
            // Do whatever you want here...
          }
        });
      });

      observer.observe(targetNode, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    setTimeout(() => {
      hideLi("My Input");
      hideLi("Range");
    }, 100);
  }

  const resetInputValue = (value) => {
    const inputs = document.querySelectorAll("input.form-control");

    inputs.forEach((input) => {
      if (input.value === value) {
        input.value = "";
      }
    });
  };

  const hideDivByClassName = (value) => {
    const divs = document.querySelectorAll("." + value);
    divs.forEach((div) => {
      div.style.display = "none";
    });
  };

  const hideTag = (inputId) => {
    const inputElement = document.getElementById(inputId);
    const inputElement2 = document.getElementsByClassName(inputId);
    if (inputElement && inputElement.parentElement) {
      inputElement.parentElement.style.display = "none";
    } else if (inputElement2 && inputElement2.parentElement) {
      inputElement2.parentElement.style.display = "none";
    }
  };
  const hideByValue = (value) => {
    const labels = document.querySelectorAll("label");

    if (labels !== null && labels.length > 0) {
      labels.forEach((label) => {
        if (label.textContent.trim() === value) {
          label.style.display = "none";
          // OR hide its parent too
          // label.parentElement.style.display = 'none';
        }
      });
    }
  };

  const hideButton = (value) => {
    // Hide button
    const buttons = document.querySelectorAll("button");

    if (buttons !== null && buttons.length > 0) {
      buttons.forEach((btn) => {
        if (btn.textContent.trim() === value) {
          btn.style.display = "none";
        }
      });
    }
  };

  const hideLi = (value) => {
    const li = document.querySelectorAll("li");
    if (li !== null && li.length > 0) {
      li.forEach((li) => {
        if (li.textContent.trim() === value) {
          li.style.display = "none";
        }
      });
    }
  };

  useEffect(() => {
    if (_.isEmpty(formJSON)) {
      console.log(formJSON);
      setEnableBtn(false);
    } else {
      setEnableBtn(true);
    }
  }, [formJSON]);

  useEffect(() => {
    if (!_.isEmpty(createSurveyData)) {
      console.log(createSurveyData);
      if (createSurveyData.status === "success") {
        const surveyData = createSurveyData.payload?.payload;
        if (!_.isEmpty(surveyData)) {
          const builderId = surveyData.id;
          console.log(builderId);
          window.parent.postMessage(
            JSON.stringify({
              status: true,
              builderId,
            }),
            CONFIG.API_URL_BROKER_ADMIN
          );
        } else {
          setShowInfoModalMsg(
            "There was an error creating survey. Please try again later."
          );
          setInfoModal(true);
        }
      } else {
        setShowInfoModalMsg(createSurveyData.error.message);
        setInfoModal(true);
      }
      dispatch(createSurveyFormClear());
      setIsLoading(false);
    }
  }, [createSurveyData]);

  useEffect(() => {
    if (infoModal) {
      setTimeout(() => {
        setInfoModal(false);
        setShowInfoModalMsg("");
      }, 5000);
    }
  }, [infoModal]);

  const addLinkFontAwesome = () => {
    var link = document.createElement("link");
    link.id = "id2";
    link.rel = "stylesheet";
    link.href = "https://use.fontawesome.com/releases/v5.13.0/css/all.css";
    document.head.appendChild(link);
  };

  const handleSubmitData = (evt) => {
    console.log("event", evt);
    if (evt.origin === CONFIG.API_URL_BROKER_ADMIN) {
      let dataObj = evt.data;
      if (typeof dataObj === "object") {
        if (dataObj && dataObj.clicked === "save") {
          // console.log('NOTES CLICKED', dataObj, evt)
          // dataObj.url = evt.origin;
          // fetchDataFromIframe(dataObj);
          if (!_.isEmpty(formJSON)) {
            console.log("Submitting survey", formJSON);
            submitSurvey();
          } else {
            console.log(formJSON);
            console.log("form is empty");
            window.parent.postMessage(
              {
                status: false,
                message: "Form is empty",
              },
              CONFIG.API_URL_BROKER_ADMIN
            );
          }
        }
      } else {
        console.log("Invalid data");
      }
    }
  };

  const handleSaveButtonClicked = (event) => {
    console.log(event);
    let dataObj =
      typeof event.data === "object" ? event.data : JSON.parse(event.data);
    if (dataObj) {
      // if (!_.isEmpty(formJSON)) {
      //     console.log('Submitting Survey')
      //     submitSurvey()
      // } else {
      //     console.log('Form is empty')
      //     window.parent.postMessage({
      //         status: false,
      //         message: 'form is empty'
      //     }, CONFIG.API_URL_BROKER_ADMIN)
      // }
    }
  };

  const submitSurvey = () => {
    if (enableBtn) {
      setIsLoading(true);
      const token = isMobile
        ? localStorage.getItem(SessionKeys.API_TOKEN)
        : localStorage.getItem(SessionKeys.API_TOKEN_BROKER);
      const postData = {
        token,
        formJSON,
      };
      if (is_edit === "1") {
        postData.is_edit = 1;
        postData.survey_template_id = surveyTemplateId;
      }
      dispatch(
        createSurveyForm({
          module: "create-survey-form",
          postData,
        })
      );
    }
  };

  const renderAlertCard = () => {
    return (
      <div
        className={`cal-alert alert-card d-flex justify-content-center ${
          infoModal ? "" : "d-none"
        }`}
      >
        <div className="shop-cart">
          <div className="shop-info justify-content-center">
            <p className="m-0">{showInfoModalMsg}</p>
          </div>
          <div className="view-cart-icon">
            <i
              className="fa fa-times cursor-pointer"
              aria-hidden="true"
              onClick={() => {
                setInfoModal(false);
                setShowInfoModalMsg("");
              }}
            ></i>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Loader start={isLoading} />
      <section className="my-credit-points learningpaths builder-form">
        <div className="position-relative">
          {renderAlertCard()}
          <div className="rows">
            <div className="mb-5 profile-left-sec ">
              {/* <div className="search_heading mt-2">
                                <p className="lable-heading_search">Create Survey</p>
                            </div> */}
              <div className="ddcd p-0">
                <div className="w-30">
                  <DndProvider backend={HTML5Backend}>
                    {!_.isEmpty(surveyRes) ? (
                      <ReactFormBuilder
                        url=""
                        toolbarItems={items}
                        saveUrl=""
                        saveAlways={false}
                        onChange={(data) => {
                          console.log(data);
                        }}
                        action_name="Submit"
                        data={formJSON}
                        // renderEditForm={props => <FormElementsEdit {...props} />}
                      />
                    ) : (
                      is_edit != "1" && (
                        <ReactFormBuilder
                          url=""
                          toolbarItems={items}
                          saveUrl=""
                          saveAlways={false}
                          onChange={(data) => {
                            console.log(data);
                          }}
                          action_name="Submit"
                          // renderEditForm={props => <FormElementsEdit {...props} />}
                        />
                      )
                    )}
                  </DndProvider>
                  <div className="d-flex justify-content-end gap-2 mt-3">
                    <div>
                      <button
                        type="button"
                        className="btn btn-primary  setup-button w-100"
                        onClick={submitSurvey}
                        disabled={!enableBtn}
                      >
                        Generate Survey
                      </button>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="btn btn-primary  setup-button w-100"
                        onClick={() => {
                          window.parent.postMessage(
                            JSON.stringify({
                              status: true,
                              message: "",
                              cancelClicked: true,
                            }),
                            CONFIG.API_URL_BROKER_ADMIN
                          );
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FormBuilderSection;
